<h2 mat-dialog-title>
  {{ 'MEETING_SCHEDULER.MEETING_ACTIONS.RESCHEDULE_MEETING' | translate }}
</h2>

<mat-dialog-content>
  <div class="row meeting-details">
    <div class="col">
      <div class="row">
        <mat-icon class="info-icon">event</mat-icon>
        <div class="col">
          <div class="bold">
            {{
              'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.CURRENT_MEETING'
                | translate
            }}
          </div>
          <div>{{ meeting.date.start | date: 'EEEE, MMM d, y' }}</div>
          <div>
            {{ meeting.date.start | date: 'h:mm aa' | lowercase }} -
            {{ meeting.date.end | date: 'h:mm aa' | lowercase }}
          </div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <mat-icon>person</mat-icon>
        <div class="col">
          <div class="bold">
            {{
              'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.GUEST'
                | translate
            }}
          </div>
          <div>{{ meeting.guest }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="reschedule-meeting-form" [formGroup]="rescheduleForm">
    <mat-form-field class="reschedule-meeting-form" appearance="outline">
      <mat-label>
        {{
          'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.DATE' | translate
        }}
      </mat-label>
      <input
        matInput
        [matDatepicker]="myDatepicker"
        [min]="today"
        formControlName="date"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="myDatepicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #myDatepicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>
        {{
          'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.TIME_SLOT'
            | translate
        }}
      </mat-label>
      <mat-select formControlName="timeSlot">
        <mat-option
          *ngFor="let timeOption of timeOptions$ | async"
          [value]="timeOption"
        >
          {{ timeOption | date: 'shortTime' }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>
        {{
          'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.MESSAGE_TO_GUEST'
            | translate
        }}
      </mat-label>
      <textarea
        matInput
        placeholder="{{
          'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.MESSAGE_TO_GUEST_PLACEHOLDER'
            | translate
        }}"
        formControlName="messageToGuest"
      ></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions appearance="outline" class="mat-dialog-actions">
  <button mat-stroked-button (click)="close()">
    <span class="cancel">
      {{
        'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.DO_NOT_RESCHEDULE'
          | translate
      }}
    </span>
  </button>

  <button
    mat-flat-button
    color="primary"
    class="reschedule-save"
    [disabled]="rescheduleForm.invalid"
    (click)="rescheduleMeeting()"
  >
    {{
      'MEETING_SCHEDULER.MEETING_ACTIONS.DIALOG.RESCHEDULE.RESCHEDULE_AND_SEND_INVITEE'
        | translate
    }}
  </button>
</mat-dialog-actions>
